import React from 'react';

const policies = {
  terms: {
    title: "Terms and Conditions",
    content: (
      <div>
        <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        <p>Welcome to PrintPro Services. By using our smart printing services, you agree to comply with and be bound by the following terms and conditions of use.</p>
        <p><strong>1. Services Provided:</strong> We provide an automated self-service printing facility. You are responsible for the documents you upload.</p>
        <p><strong>2. User Responsibilities:</strong> You must not print illegal, copyrighted, or sensitive materials. We are not liable for the content of your printed documents.</p>
        <p><strong>3. Payments:</strong> All payments are processed securely. You agree to pay the stated price per page before the printing begins.</p>
        <p><strong>4. Liability:</strong> PrintPro is not responsible for delays caused by machine malfunction, internet outage, or paper jams. However, we ensure fair resolution in case of failed jobs.</p>
      </div>
    )
  },
  privacy: {
    title: "Privacy Policy",
    content: (
      <div>
        <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        <p>At PrintPro, your privacy is our priority.</p>
        <p><strong>1. Data Collection:</strong> We collect your uploaded PDF files solely for the purpose of printing them.</p>
        <p><strong>2. Data Retention:</strong> All uploaded files are automatically deleted from our servers immediately after the print job is completed or if the job fails. We do not store your documents.</p>
        <p><strong>3. Payment Information:</strong> We do not store your credit card or payment details. All transactions are securely handled by Razorpay.</p>
        <p><strong>4. Contact Information:</strong> We may use your email or phone number to send payment receipts or contact you regarding a failed print job.</p>
      </div>
    )
  },
  refund: {
    title: "Refund & Cancellation Policy",
    content: (
      <div>
        <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        <p><strong>1. Instant Refunds:</strong> If you make a payment but the printer fails to dispense your pages (e.g., due to paper jam or offline status), our system will automatically detect the failure and initiate an instant refund.</p>
        <p><strong>2. Refund Processing Time:</strong> Automatic refunds are processed instantly by our system. However, it may take 3-5 business days for the amount to reflect in your original payment method depending on your bank.</p>
        <p><strong>3. Cancellations:</strong> Once a print job is successfully paid for and sent to the printer, it cannot be cancelled as the printing process begins immediately.</p>
        <p><strong>4. Manual Refunds:</strong> In case the automatic refund fails, you can request a manual refund by contacting us with your Transaction ID.</p>
      </div>
    )
  },
  contact: {
    title: "Contact Us",
    content: (
      <div>
        <p>If you have any questions, concerns, or need support with a failed print job, please reach out to us:</p>
        <br/>
        <p><strong>Email:</strong> nahatakaran52@gmail.com</p>
        <p><strong>Phone:</strong> +91 6350291328</p>
        <p><strong>Address:</strong> AI & Robotics Lab, ECB College, Bikaner, Rajasthan, India</p>
        <br/>
        <p>Our support team is available during college working hours. We aim to respond to all queries within 24 hours.</p>
      </div>
    )
  }
};

type PolicyKey = keyof typeof policies;

const PolicyModal = ({ type, onClose }: { type: PolicyKey | null | string, onClose: () => void }) => {
  if (!type || !(type in policies)) return null;

  const policy = policies[type as PolicyKey];

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 10000, display: 'flex',
      justifyContent: 'center', alignItems: 'center', padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'white', padding: '2rem', borderRadius: '12px',
        width: '100%', maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '1rem', marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', margin: 0, color: '#1f2937' }}>{policy.title}</h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#6b7280'
          }}>&times;</button>
        </div>
        <div style={{ color: '#4b5563', lineHeight: '1.6' }}>
          {policy.content}
        </div>
        <div style={{ marginTop: '2rem', textAlign: 'right' }}>
          <button onClick={onClose} style={{
            padding: '0.75rem 1.5rem', borderRadius: '6px', border: 'none',
            backgroundColor: '#2563eb', color: 'white', cursor: 'pointer', fontWeight: '500'
          }}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
